import {createHelpers} from 'vuex-map-fields'
import Vue from "vue";
import {
  clearObjectKeys,
  replaceArrayContents,
  cloneObject,
  transformArrayModelsToObject
} from "../../utilities/utilityOperators";

/** APIs */
import {
  apiLoadPatientCase,
} from '../api/apiObservables';

import apiHelper from '../../utilities/apiObsHelpers'

/** Obsteric Case FOrm State */
export const GETTER_CASE_FORM_STATE = 'caseForm/getCaseFormState';
export const GETTER_CASE_FORM_STATE_FIELD = 'getCaseFormStateField';
export const SETTER_CASE_FORM_STATE_FIELD = 'setCaseFormStateField';

export const MUTATION_SET_CASE_FORM = 'caseForm/setCaseForm';
export const MUTATION_SET_CASE_FORM_TRANSFORM = 'caseForm/setCaseFormTransform';
export const ACTION_CREATE_NEW_CASE_FORM = 'caseForm/createNew';
export const ACTION_EDIT_CASE_FORM = 'caseForm/editCase';

export const MUTATION_CLEAR_CASE_FORM_STATE_FIELDS = 'caseForm/clearCaseFormStateFields';
export const MUTATATION_SET_CASE_FORM_NEONATAL_VALUE = 'caseForm/setCaseFormNeonatalValue';
export const MUTATION_INIT_CASE_FORM_FIELD_VALUES = 'caseForm/initCaseFormFieldValue';
/** Medical History Information */
export const GETTER_MEDICAL_HISTORY = 'medicalhistory/getMedicalHistory';
export const MUTATE_UPDATE_MEDICAL_HISTORY = 'medicalhistory/mutateUpdateMedicalHistory';
export const MUTATE_SET_MEDICAL_HISTORY = 'medicalhistory/mutateSetMedicalHistory';
export const ACTION_UPDATE_MEDICAL_HISTORY = 'medicalhistory/actionUpdateMedicalHistory'
/** Obstetric History Information */
export const GETTER_OBSTETRIC_HISTORY = 'obstetrichistory/getObstetricHistory';
export const MUTATE_UPDATE_OBSTETRIC_HISTORY = 'obstetrichistory/mutateUpdateObstetricHistory';
export const MUTATE_SET_OBSTETRIC_HISTORY = 'obstetrichistory/mutateSetObstetricHistory';
export const ACTION_UPDATE_OBSTETRIC_HISTORY = 'obstetrichistory/actionUpdateObstetricHistory'
/** Concomitant Procedures Information */
export const GETTER_CONCOMITTANT = 'concomittant/getConcomittant';
export const MUTATE_UPDATE_CONCOMITTANT = 'concomittant/mutateUpdateConcomittant';
export const MUTATE_UPDATE_CONCOMITTANT_OTHERS = 'concomittant/mutateUpdateConcomittantOthers';
export const MUTATE_SET_CONCOMITTANT = 'concomittant/mutateSetConcomittant';
export const ACTION_UPDATE_CONCOMITTANT = 'concomittant/actionUpdateConcomittant';
/** OB Procedures Information */
export const GETTER_OBPROCEDURE = 'concomittant/getOBProcedure';
export const MUTATE_UPDATE_OBPROCEDURE = 'concomittant/mutateUpdateOBProcedure';
export const MUTATE_SET_OBPROCEDURE = 'concomittant/mutateSetOBProcedure';
export const ACTION_UPDATE_OBPROCEDURE = 'concomittant/actionUpdate';

export const GETTER_GYNE_DIAGNOSIS = 'gyneConditions/getDiagnosis';
export const MUTATE_SET_GYNE_DIAGNOSIS = 'gyneConditions/mutateSetDiagnosis';
export const ACTION_UPDATE_GYNE_DIAGNOSIS = 'gyneConditions/actionUpdateDiagnosis';

export const GETTER_PREGNANCY_INDICATION = 'pregnancyIndications/getIndications';
export const MUTATE_SET_PREGNANCY_INDICATION = 'pregnancyIndications/mutateSetIndications';
export const ACTION_UPDATE_PREGNANCY_INDICATION = 'pregnancyIndications/actionUpdateIndications';
export const MUTATE_REMOVE_PREGNANCY_INDICATION = 'pregnancyIndications/mutateRemoveIndications';

export const GETTER_PREGNANCY_INDICATION2 = 'pregnancyIndications/getIndications2';
export const MUTATE_SET_PREGNANCY_INDICATION2 = 'pregnancyIndications/mutateSetIndications2';
export const ACTION_UPDATE_PREGNANCY_INDICATION2 = 'pregnancyIndications/actionUpdateIndications2';
export const MUTATE_REMOVE_PREGNANCY_INDICATION2 = 'pregnancyIndications/mutateRemoveIndications2';

export const GETTER_MORBIDITY = 'morbodity/get';
export const MUTATE_SET_MORBIDITY = 'morbodity/set';
export const ACTION_UPDATE_MORBIDITY = 'morbodity/update';
export const MUTATE_REMOVE_MORBIDITY = ' morbidity/remove';

export const GETTER_GYNE_MORBIDITY        = 'gynemorbodity/get';
export const MUTATE_SET_GYNE_MORBIDITY    = 'gynemorbodity/set';
export const ACTION_UPDATE_GYNE_MORBIDITY = 'gynemorbodity/update';
export const MUTATE_REMOVE_GYNE_MORBIDITY = 'gynemorbidity/remove';

export const ACTION_REMOVE_CASE_MULTISELECT_ITEM = 'case/REMOVE_MULTISELECT_ITEM';
export const MUTATE_REMOVE_CASE_MULTISELECT_ITEM = 'case/MUTATE_REMOVE_MULTISELECT_ITEM';

export const GETTER_IS_CLOSE = 'caseForm/getIsClose';

const {getCaseFormStateField, setCaseFormStateField} = createHelpers({
  getterType: GETTER_CASE_FORM_STATE_FIELD,
  mutationType: SETTER_CASE_FORM_STATE_FIELD,
});

const blankform = {
  // patient info
  weight:null,
  height:null,
  bmi:null,
  //admission
  admissionDate: null,
  room: null,
  age: null,
  caseNum: null,
  // OB Score
  obscoreG: null,
  obscoreP: null,
  obscoreFT: null,
  obscorePr: null,
  obscoreAb: null,
  obscoreLB: null,
  // Form types
  caseFormType: null,
  isPostpartum: null,
  isGyne: false,
  isPregnancy: false,
  isDelivered: false,
  isTOLAC: null,
  //pregnancy
  admissionAOGType:1,
  admissionAOG:null,
  admissionWeeks: null,
  admissionDays: null,
  pregnancyType: null,
  isHeterotopic: false,
  abortionType: null,
  ectopicType: null,
  molarType: null,
  deliveryDate: null,
  deliveryAOGType:1,
  deliveryAOG:null,
  deliveryWeeks: null,
  deliveryDays: null,
  deliveryManner: null,
  primaryRepeat: null,
  incision: null,
  CSBilateralSalpingectomy:null,
  CSBTL:null,

// Additional Manner of delivery fields
  deliveryManner2: null,
  primaryRepeat2: null,
  incision2: null,
  CSBilateralSalpingectomy2: null,
  CSBTL2: null,
  deliveryIndication2: {},

// Complicated Pregnancy
  complicatedPregnancy: null,
// Induced Labor
  isInduced: null,
  inducedIndication: null,
  inducedMethod: null,
  inducedComplication: null,
  returnToOR: null,
  pcosHistory: null,
  pcosSymptoms: null,

  deliveryIndication: {},
  concomitantProcedure: {},
  obProcedure: {},
  isMedical:false,
  isSurgical:false,
  isChemotherapy:false,
  isRadiotherapy:false,
  isOthers:false,
  otherProcedure:null,
  infantsNumber: null,
  neonatal: [],

  //gyne
  gyneOrgan: null,
  organCondition: null,
  gyneDiagnosis: null,
  gtdDiagnosis: null,
  gtdComplication: null,
  gtdComplicationOthers:null,
  medicalSurgical: null,
  surgicalIntervention: null,
  surgicalInterventionOthers: null,

  //MIGS
  MIGSSurgeon: null,
  MIGSSurgeonPSGE: false,
  MIGSSurgeonPSRM: false,
  MIGSAssist: null,
  MIGSAssistPSGE: false,
  MIGSAssistPSRM: false,
  //discharge
  dischargeDate: null,
  motherCondition: null,
  antecedent: null,
  antecedentType: null,
  // Removed because of June 2 Revisions
  //antecedentCause: null,
  immediateCause: null,
  immediateCauseOthers:null,
  complicationOnset: null,
  complicationOnsetSpecific: null,
  deathTiming: null,
  deathTimingComplication: null,
  deathReviewed: null,
  // Medical History
  medicalHistory: {},
  // OB History
  obstetricHistory: {},
  // Gyme
  gynecologicalDiagnosis: {},
  // Morbidity
  morbidities: {},
  gynemorbidities: {},

  // March 2 Additions
  institutionalDelivery: null,

  hasFailedMIS:null,


  isClose: false,
  submissionId: null
};

const state = Object.assign({}, blankform);

const getters = {
  [GETTER_CASE_FORM_STATE]      : (state) => state,
  [GETTER_MEDICAL_HISTORY]      : (state) => state.medicalHistory,
  [GETTER_OBSTETRIC_HISTORY]    : (state) => state.obstetricHistory,
  [GETTER_CONCOMITTANT]         : (state) => state.concomitantProcedure,
  [GETTER_OBPROCEDURE]          : (state) => state.obProcedure,
  [GETTER_GYNE_DIAGNOSIS]       : (state) => state.gynecologicalDiagnosis,
  [GETTER_PREGNANCY_INDICATION] : (state) => state.deliveryIndication,
  [GETTER_PREGNANCY_INDICATION2]: (state) => state.deliveryIndication2,
  [GETTER_MORBIDITY]            : (state) => state.morbidities,
  [GETTER_GYNE_MORBIDITY]       : (state) => state.gynemorbidities,
  [GETTER_IS_CLOSE]             : (state) => state.isClose,
  getCaseFormStateField,
};

const mutations = {
  [MUTATION_CLEAR_CASE_FORM_STATE_FIELDS]: (state) => {
    clearObjectKeys(state);
    state.isGyne = false;
    state.isPregnancy = false;
    state.isDelivered = false;
    state.isHeterotopic = false;
    // Temporary set to empty object
    state.morbidities = {};
    state.gynemorbidities = {};
    state.obProcedure = {};
    state.concomitantProcedure = {};
    state.medicalHistory = {};
    state.obstetricHistory = {};
    state.deliveryIndication = {};
    state.gynecologicalDiagnosis = {};
  },
  [MUTATION_SET_CASE_FORM]: (state, payload) => {
    Object.assign(state, payload)
  },
  [MUTATION_SET_CASE_FORM_TRANSFORM]: (state, payload) => {
    Object.assign(state, transformArrayModelsToObject(payload))
    state.admissionDate = payload.admissionDate ? new Date(payload.admissionDate) : null;
    state.dischargeDate = payload.dischargeDate ? new Date(payload.dischargeDate) : null;
    state.deliveryDate = payload.deliveryDate ? new Date(payload.deliveryDate) : null;
  },
  [MUTATATION_SET_CASE_FORM_NEONATAL_VALUE]: (state, payload) => {
    replaceArrayContents(state.neonatal)(payload)
  },
  [MUTATE_UPDATE_CONCOMITTANT_OTHERS]: (state, _) => {
    //let field = state.concomitantProcedure = obj;
    //if (field) field.others = value
  },
  setCaseFormStateField,
  [MUTATE_UPDATE_MEDICAL_HISTORY] : (state, obj) => {
    state.medicalHistory = obj;
  },
  [MUTATE_SET_MEDICAL_HISTORY] : (state, obj) => {
    state.medicalHistory = obj
  },
  [MUTATE_UPDATE_OBSTETRIC_HISTORY] : (state, obj) => {
    state.obstetricHistory = obj;
  },
  [MUTATE_SET_OBSTETRIC_HISTORY] : (state, obj) => {
    state.obstetricHistory = obj
  },
  [MUTATE_UPDATE_CONCOMITTANT] : (state, obj) => {
    state.concomitantProcedure = obj;
  },
  [MUTATE_SET_CONCOMITTANT] : (state, obj) => {
    state.concomitantProcedure = obj
  },
  [MUTATE_UPDATE_OBPROCEDURE] : (state, obj) => {
    state.obProcedure = obj;
  },
  [MUTATE_SET_OBPROCEDURE] : (state, obj) => {
    state.obProcedure = obj
  },
  [MUTATE_SET_GYNE_DIAGNOSIS]: (state, obj) => {
    state.gynecologicalDiagnosis = obj;
  },
  [MUTATE_SET_PREGNANCY_INDICATION]: (state, obj) => {
    state.deliveryIndication = obj;
  },
  [MUTATE_SET_PREGNANCY_INDICATION2]: (state, obj) => {
    state.deliveryIndication2 = obj;
  },
  [MUTATE_SET_MORBIDITY]: (state, obj) => {
    state.morbidities = obj;
  },
  [MUTATE_SET_GYNE_MORBIDITY]: (state, obj) => {
    state.gynemorbidities = obj;
  },
  [MUTATE_REMOVE_CASE_MULTISELECT_ITEM]: (state, {section, conditionId}) => {
    Vue.delete(state[section], conditionId);
  },
  [MUTATE_REMOVE_PREGNANCY_INDICATION]: (state, id) => {
    if(state.deliveryIndication && state.deliveryIndication[id]) {
      Vue.delete(state.deliveryIndication, id);
    }
  },
  [MUTATE_REMOVE_PREGNANCY_INDICATION2]: (state, id) => {
    if(state.deliveryIndication2 && state.deliveryIndication2[id]) {
      Vue.delete(state.deliveryIndication2, id);
    }
  },
  [MUTATE_REMOVE_MORBIDITY]: (state, id) => {
    if(state.morbidities && state.morbidities[id]) {
      Vue.delete(state.morbidities, id);
    }
  },
  [MUTATE_REMOVE_GYNE_MORBIDITY]: (state, id) => {
    if(state.gynemorbidities && state.gynemorbidities[id]) {
      Vue.delete(state.gynemorbidities, id);
    }
  }
};

const actions = {
  [ACTION_UPDATE_MEDICAL_HISTORY] : (context, obj) => {
    context.commit(MUTATE_UPDATE_MEDICAL_HISTORY, obj)
  },
  [ACTION_UPDATE_OBSTETRIC_HISTORY] : (context, obj) => {
    context.commit(MUTATE_UPDATE_OBSTETRIC_HISTORY, obj)
  },
  [ACTION_UPDATE_CONCOMITTANT] : (context, obj) => {
    context.commit(MUTATE_UPDATE_CONCOMITTANT, obj)
  },
  [ACTION_UPDATE_OBPROCEDURE] : (context, obj) => {
    context.commit(MUTATE_UPDATE_OBPROCEDURE, obj)
  },
  [ACTION_UPDATE_GYNE_DIAGNOSIS]: (context, obj) => {
    context.commit(MUTATE_SET_GYNE_DIAGNOSIS, obj)
  },
  [ACTION_UPDATE_PREGNANCY_INDICATION]: (context, obj) => {
    context.commit(MUTATE_SET_PREGNANCY_INDICATION, obj);
  },
  [ACTION_UPDATE_PREGNANCY_INDICATION2]: (context, obj) => {
    context.commit(MUTATE_SET_PREGNANCY_INDICATION2, obj);
  },
  [ACTION_UPDATE_MORBIDITY]: (context, obj) => {
    context.commit(MUTATE_SET_MORBIDITY, obj);
  },
  [ACTION_UPDATE_GYNE_MORBIDITY]: (context, obj) => {
    context.commit(MUTATE_SET_GYNE_MORBIDITY, obj);
  },
  [ACTION_EDIT_CASE_FORM] : apiHelper.mutateResult(
      apiLoadPatientCase,
    MUTATION_SET_CASE_FORM_TRANSFORM),
  [ACTION_CREATE_NEW_CASE_FORM] : (context, caseNum) => {
    return new Promise((resolve) => {
      const blank = cloneObject(blankform);
      blank.caseNum = caseNum
      context.commit(MUTATION_SET_CASE_FORM,  blank)
      resolve();
    });
  },
  [ACTION_REMOVE_CASE_MULTISELECT_ITEM]: ({state, commit}, {section, conditionId}) => {
    const c = state[section];
    if(c && c[conditionId]) {
      commit(MUTATE_REMOVE_CASE_MULTISELECT_ITEM, {section, conditionId});
    }
  }
};


export default{
  state,
  getters,
  mutations,
  actions
}
